import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateChatImages } from '../../../actions/chatImages';
import { currentOpenChatIDSelector, chatImagesSelector } from '../../../selectors';

export const useFullscreenGalleryPagination = (slideIndex: number, setCurrentSlide: (index: number) => void): void => {
  const chatImages = useSelector(chatImagesSelector);
  const chatId = useSelector(currentOpenChatIDSelector);
  const dispatch = useDispatch();

  React.useEffect(() => {
    setCurrentSlide(Math.max(slideIndex, 0));

    const loadedFilesCount = chatImages?.files?.length ?? 0;

    // Догружаем следующую страницу, когда дошли до последнего загруженного слайда — самого старого фото.
    // Подмешанный в конец слайд (фото, которого ещё нет в списке) в счёт не идёт.
    if (slideIndex >= 0 && loadedFilesCount === slideIndex + 1 && chatImages?.page?.canLoadMore) {
      dispatch(updateChatImages({ chatId: chatId as string, offset: loadedFilesCount }));
    }
  }, [chatId, chatImages, dispatch, slideIndex, setCurrentSlide]);
};
